module.exports = __webpack_public_path__ + "img/no-avartar.998fcaf5.jpg";